module.exports = __webpack_public_path__ + "img/Bodice-Front-B8-Gc-Da-Eb.c59a9154.png";